(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delta-presale-nav"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const navbar = document.getElementById('delta-navbar');
    const navLinks = document.querySelectorAll('.product-nav-link[data-target]');
    
    const sections = Array.from(navLinks).map(link => {
        const targetId = link.getAttribute('data-target').substring(1);
        return document.getElementById(targetId);
    }).filter(el => el !== null); 

    const targetSection = document.getElementById('part-sale-banner');

    if (targetSection) {
        const navbarObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    navbar.classList.remove('visible');
                } else {
                    navbar.classList.add('visible');
                }
            });
        }, {
            threshold: 0.1 
        });
        navbarObserver.observe(targetSection);
    }

    const sectionObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const id = entry.target.getAttribute('id');
                navLinks.forEach(link => {
                    link.classList.remove('active');
                });
                const activeLink = document.querySelector(`.product-nav-link[data-target="#${id}"]`);
                if (activeLink) {
                    activeLink.classList.add('active');
                }
            }
        });
    }, {
        rootMargin: '-50% 0px -50% 0px' 
    });

    sections.forEach(section => {
        sectionObserver.observe(section);
    });

    navLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('data-target').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - navbar.offsetHeight,
                    behavior: 'smooth'
                });
            }
        });
    });
});

  } catch(e) { console.error(e); }
})();
})();
